import { SelectScreen } from 'components/Funnelling/screens/SelectScreen';
import type { Skill } from 'lib/sdks/search';
import {
  FunnellingBackButton,
  FunnellingArticle,
  FunnellingFooter,
} from '../styles';
import type { ScreenCommonProps } from '../types';

type TopLevelCategorySelectProps = {
  skills: Skill[];
} & ScreenCommonProps<[choice: { title: string; value: number }]>;

const TopLevelCategorySelect = ({
  skills,
  onComplete,
  onBack,
}: TopLevelCategorySelectProps) => {
  const choices = skills.map(skill => ({
    title: skill.label,
    value: skill.id,
  }));

  return (
    <FunnellingArticle>
      <SelectScreen
        title="What service do you need?"
        choices={choices}
        showSubheading
        showDescription
        onSelect={onComplete}
      />

      <FunnellingFooter>
        <FunnellingBackButton onClick={onBack} />
      </FunnellingFooter>
    </FunnellingArticle>
  );
};

export default TopLevelCategorySelect;
